import {
  FileText, Home, Hammer, Network, Search, KeyRound, Scale, Calculator,
  Handshake, TrendingUp, Landmark, BarChart3, Building2, Users, Coins,
  ShieldCheck, Compass, MessagesSquare,
} from "lucide-react";

export const ICONS = {
  "file-text": FileText,
  home: Home,
  hammer: Hammer,
  network: Network,
  search: Search,
  key: KeyRound,
  scale: Scale,
  calculator: Calculator,
  handshake: Handshake,
  "trending-up": TrendingUp,
  landmark: Landmark,
  "bar-chart": BarChart3,
  building: Building2,
  users: Users,
  coins: Coins,
  "shield-check": ShieldCheck,
  compass: Compass,
  messages: MessagesSquare,
};

export const ICON_NAMES = Object.keys(ICONS);
